import * as _ from 'lodash';
import defaultConfig from './default';

console.log('env', process.env.REACT_APP_ENV);

var config = {};
if (
  process.env.REACT_APP_ENV === 'dev' ||
  process.env.REACT_APP_ENV === 'stage' ||
  process.env.REACT_APP_ENV === 'prod'
) {
  config = require('./env/' + process.env.REACT_APP_ENV).default;
}

var merged = _.merge({}, defaultConfig, config);

export default merged;
